/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { Tokens } from '@jda/lui-common-component-library-mui5';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(theme => ({
  root: {
    backgroundColor: theme.palette.background.paper,
  },
  loaderWrapper: {
    backgroundColor: theme.palette.background.paper,
    marginTop: Tokens.spacing['$sp-1'],
    borderRadius: Tokens.spacing['$sp-1-5'],
    position: 'absolute',
    height: '100%'
  },
  innerContent: {
    position: 'absolute',
    top: '30%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    textAlign: 'center'
  },
  toolbar: {
    backgroundColor: theme.palette.grey['50'],
    alignItems: 'center'
  },
  searchContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  searchField: {
    width: '225px',
    margin: `0 ${Tokens.spacing['$sp-4']}`,
    color: theme.palette.text.secondary,
    borderBottomStyle: 'solid',
    // borderBottomWidth: Tokens.spacing['$sp-0-25'],
    // borderBottomColor: theme.palette.text.secondary
  },
  conjuction: {
    color: theme.palette.text.secondary,
    textAlign: 'center'
  },
  searchKeyDD: {
    padding: theme.spacing(1, 2),
    '& #dropdown-select-user-search-key': {
      borderBottomColor: theme.palette.text.secondary
    }
  },
  buttonPanel: {
    display: 'flex',
    justifyContent: 'flex-end',
    '& button': {
      marginRight: Tokens.spacing['$sp-2']
    }
  },
  policyRuleLine: {
    display: 'flex',
    alignItems: 'center',
    paddingBottom: Tokens.spacing['$sp-2'],
    '& svg': {
      marginRight: Tokens.spacing['$sp-2']
    }
  },
  centerLoader: {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex: 9999,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }
}));
